import { render, staticRenderFns } from "./PNumberSimple.vue?vue&type=template&id=04e9a09a"
import script from "./PNumberSimple.vue?vue&type=script&lang=js"
export * from "./PNumberSimple.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports